export const IconAddBulk = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M10.4135 29.333L21.5868 29.333C26.4402 29.333 29.3335 26.4397 29.3335 21.5863L29.3335 10.4263C29.3335 5.55967 26.4402 2.66634 21.5868 2.66634L10.4268 2.66634C5.5735 2.66634 2.68016 5.55967 2.68016 10.413L2.68016 21.5863C2.66683 26.4397 5.56016 29.333 10.4135 29.333Z"/>
      <path d="M10.6668 16.9997L15.0002 16.9997L15.0002 21.333C15.0002 21.8797 15.4535 22.333 16.0002 22.333C16.5468 22.333 17.0002 21.8797 17.0002 21.333L17.0002 16.9997L21.3335 16.9997C21.8802 16.9997 22.3335 16.5463 22.3335 15.9997C22.3335 15.453 21.8802 14.9997 21.3335 14.9997L17.0002 14.9997L17.0002 10.6663C17.0002 10.1197 16.5468 9.66634 16.0002 9.66634C15.4535 9.66634 15.0002 10.1197 15.0002 10.6663L15.0002 14.9997L10.6668 14.9997C10.1202 14.9997 9.66683 15.453 9.66683 15.9997C9.66683 16.5463 10.1202 16.9997 10.6668 16.9997Z"/>
    </svg>
  );
};